import React from "react";
import { CrewPilotNavSectionHeader } from "../CrewPilotNavRow";
import "./financeWorkspaceNav.css";

/**
 * Permission-filtered destinations on the Finance landing page.
 * Callers pass only the workspaces the actor can open. Empty slots are not rendered.
 */
export function FinanceWorkspaceNav({ links, onOpen }) {
  if (!links?.length) {
    return null;
  }

  return (
    <div className="finance-workspace-nav">
      <CrewPilotNavSectionHeader>Workspaces</CrewPilotNavSectionHeader>
      <div
        className="finance-workspace-grid"
        data-count={String(links.length)}
        role="navigation"
        aria-label="Finance workspaces"
      >
        {links.map((link) => (
          <button
            key={link.id}
            type="button"
            className="finance-workspace-tile"
            onClick={() => onOpen?.(link.id)}
          >
            <span>{link.label}</span>
            <span className="finance-workspace-tile__go" aria-hidden="true">
              ›
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
